import { ReactNode } from 'react';

export interface FormFieldProps {
  label: string;
  children: ReactNode;
  error?: string;
  required?: boolean;
  hint?: string;
  className?: string;
}

/**
 * Form field wrapper with consistent label, input, error, and hint layout
 */
export function FormField({ label, children, error, required, hint, className = '' }: FormFieldProps) {
  return (
    <div data-tsx-id="form-field" className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-zinc-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {children}
      {hint && !error && (
        <p className="text-xs text-zinc-500">{hint}</p>
      )}
      {error && (
        <p className="text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}
